import { MintOauthRedirectPage } from "@/features/mintOauthRedirect/pages";
import { withAuth } from "@/hoc/withAuth";

const MintOauthRedirect = () => {
  return <MintOauthRedirectPage />;
};

export default withAuth(MintOauthRedirect);
